import { canUseDOM } from 'exenv';

export default function getQueryParameterByName(queryName) {
  if (canUseDOM) {
    let name = queryName;
    // eslint-disable-next-line no-useless-escape
    name = name.replace(/[\[\]]/g, '\\$&');
    const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
    const results = regex.exec(window.location.href);
    if (!results) {
      return null;
    }
    if (!results[2]) {
      return '';
    }
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }
  return null;
}

export function correctSubDomain(url) {
  if (url && url.indexOf('https://www.') === -1 && typeof url === 'string') {
    return url.replace('https://', 'https://www.');
  }

  return url;
}
